import React, { useEffect } from "react";
import MaterialBox from "../../../components/MaterialBox";
import MaterialTypography from "../../../components/MaterialTypography";
import soon from "../../../assest/commingsoonremovebg.png";
import PageLayout from "../../../layoutcontainers/PageLayout";
import { useNavigate } from "react-router-dom";
import { postData } from "../../Utils/Baseurl";
import { useAuth } from "../../../context/AuthContext";

function LandingPage() {
  const navigate = useNavigate();
  const { currentUser, setCurrentUser } = useAuth();

  useEffect(() => {
    const fetchUserDetails = async () => {
      const formdata = new FormData();
      // formdata.append("user_id", "69");
      formdata.append("user_id", currentUser);

      try {
        const res = await postData("api/getuserdetails/", formdata);

        sessionStorage.setItem("currentUser", JSON.stringify(res?.data));
            setCurrentUser(res?.data);
        navigate("/dashboards/employee-dashboard");
      } catch (error) {
        console.error("Error fetching user details:", error);
      } finally {
        // setCircleLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  return (
    <div>
      <PageLayout background="white" height="100%" showNavbar disableFooter>
        <MaterialBox
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <img
            src={soon}
            alt="image not found"
            style={{ width: "400px", height: "400px" }}
          />
          <MaterialTypography
            variant="h2"
            color="dark"
            fontWeight="bold"
            sx={{
              fontStyle: "italic",
              fontFamily: '"Dancing Script", cursive',
            }}
          >
            {" "}
            Loading...
          </MaterialTypography>
          <MaterialTypography variant="caption" color="text">
            We're working hard to bring this page to life. Please check back
            soon.
          </MaterialTypography>
        </MaterialBox>
      </PageLayout>
    </div>
  );
}

export default LandingPage;
